<div class="modal-content">
    <div class="modal-header">
        <h4 id="modal-title" class="modal-title">Advanced Reorder</h4>
        <button type="button" aria-label="Close button" aria-describedby="modal-title" class="close"
            (click)="modal.dismiss()">
            <span aria-hidden="true">x</span></button>
    </div>
    <div class="modal-body">
        This item has subs or listings custom settings, If you want to continue those settings will not be used for this calculation.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-brand" (click)="modal.close(true)">Continue</button>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Close</button>
    </div>
</div>